export const GlobalSearchEndpoints = {
  hierarchy: (membershipSlug: string) => `/rest/v2/searches/${membershipSlug}/hierarchy`,
  find: (membershipSlug: string) => `/rest/v2/searches/${membershipSlug}/find`
}

export const MAX_RESULTS_PER_PAGE = 5
